import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { MeshLinkSize, MeshLinkType } from '../kz-mesh-link-options';
import { isPlatformBrowser } from '@angular/common';
import { MediaQueriesService } from '../../../../shared/services/utilities/media-queries.service';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { KzIconsRegistryService } from '../../icon/kz-icons-registry.service';
import { kzIconsArrowright } from '../../icon/generated-icons/kzIcons-arrowright.icon';
import { map } from 'rxjs/operators';

@Component({
  selector: '[kzMeshLink]',
  exportAs: 'kzMeshLink',
  styleUrls: ['./kz-mesh-link.component.scss'],
  host: {
    '[class]': '"kz-mesh-link " + classes ',
  },
  template: `<ng-container *ngTemplateOutlet="(mobileVersion$ | async) ? mobileLink : desktopLink"></ng-container>
  <ng-template #desktopLink><span kzButton [buttonSize]="meshLinkSize" buttonTxtStyle="none" [buttonContext]="meshLinkType"><span><ng-template *ngTemplateOutlet="content"></ng-template></span></span></ng-template>
  <ng-template #mobileLink><span><ng-template *ngTemplateOutlet="content"></ng-template></span><kz-icons name="arrowright"></kz-icons></ng-template>
  <ng-template #content><ng-content></ng-content></ng-template>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KzMeshLinkComponent implements OnInit {

  private _classes: string;

  get classes(): string {
    return this._classes;
  }

  private _meshLinkType: MeshLinkType = 'secondary';

  @Input()
  set meshLinkType(type: MeshLinkType) {
    this._meshLinkType = type;
  }

  get meshLinkType(): MeshLinkType {
    return this._meshLinkType;
  }

  private _meshLinkSize: MeshLinkSize = 'small';

  @Input()
  set meshLinkSize(size: MeshLinkSize) {
    this._meshLinkSize = size;
  }

  get meshLinkSize(): MeshLinkSize {
    return this._meshLinkSize;
  }

  private _meshLinkBreakPoint: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  @Input()
  set meshLinkBreakPoint(val: number) {
    this._meshLinkBreakPoint.next(val);
  }

  get meshLinkBreakPoint(): number {
    return this._meshLinkBreakPoint.getValue();
  }

  private _meshLinkBreakPointVersion: 'stacked' | 'default' = 'stacked';

  @Input()
  set meshLinkBreakPointVersion(val: 'stacked' | 'default') {
    this._meshLinkBreakPointVersion = val;
  }

  get meshLinkBreakPointVersion(): 'stacked' | 'default' {
    return this._meshLinkBreakPointVersion;
  }

  public mobileVersion$: Observable<boolean>;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object,
    private mediaQueriesService: MediaQueriesService,
    private kzIconsRegistryService: KzIconsRegistryService,
    public elementRef: ElementRef,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsArrowright]);
  }

  ngOnInit(): void {
    this.mobileVersion$ = (isPlatformBrowser(this.platformId)
      ? this._meshLinkBreakPoint.asObservable().pipe(switchMap((bp) => this.mediaQueriesService.isLesserThan(bp)))
      : of(false)).pipe(
      map((isMobile) => {
        this._classes = isMobile && this.meshLinkBreakPointVersion === 'stacked' ? 'kz-mesh-link--mobile' : '';
        return isMobile && this.meshLinkBreakPointVersion === 'stacked';
      }),
    );
  }

}
